export default "__VITE_PUBLIC_ASSET__3b94f20d__"